import { combineReducers } from 'redux';

import authByEmailReducer from "./auth-by-email/reducer";
import authUserReducer from "./auth-user/reducer";
import authByFacebookReducer from "./auth-by-facebook/reducer";
import authByGoogleReducer from "./auth-by-google/reducer";
import registerByEmailReducer from "./register-by-email/reducer";

export default combineReducers({
  registerByEmail: registerByEmailReducer,
  authByEmail: authByEmailReducer,
  authByFacebook: authByFacebookReducer,
  authByGoogle: authByGoogleReducer,
  user: authUserReducer
});